import React, { useEffect, useRef } from "react"
import { usePromoCodeActions } from "components/Basket/components/PromoCodes/hooks/usePromoCode"
import { CheckIcon } from "components/SVG/CheckIcon"
import { color } from "lib/theme/theme.css"
import { promoCodeValue } from "components/Basket/components/PromoCodes/constants"
import { activatedPromoText } from "../AddPromoCodeBox/AddPromoCodeBox.css"
import {
  activatePromo,
  isActivatedPromo,
  promoContainer,
  promoWrapper,
  showPromoWrapper,
  promoBannerSvg,
  promoBgText,
  promoBgSvg,
  promoBgSize,
  promoBgRemoveDistance,
} from "./AddPromoCodeBar.css"

type Props = {
  showPromoText?: boolean
  useBgPromoText?: boolean
}

export const AddPromoCodeBar = ({ showPromoText, useBgPromoText }: Props) => {
  const { onUsePromoCode, isPromoCodeActivated, isPromoCodeRejected } =
    usePromoCodeActions()
  const promoBarRef = useRef(null)

  useEffect(() => {
    const promoBar = promoBarRef?.current as unknown as HTMLElement
    setTimeout(() => {
      promoBar.classList.add(showPromoWrapper)
    }, 200)
  }, [onUsePromoCode])

  return (
    <>
      <div
        ref={promoBarRef}
        className={`${promoWrapper} ${useBgPromoText && promoBgSize} ${
          (isPromoCodeActivated || isPromoCodeRejected) && isActivatedPromo
        }`}
      >
        {(!isPromoCodeActivated || !isPromoCodeRejected) && (
          <div
            className={`${promoContainer} ${
              useBgPromoText && promoBgRemoveDistance
            }`}
          >
            <span> 20% Off Your First Order: {promoCodeValue} </span>
            <span
              onClick={onUsePromoCode}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  onUsePromoCode()
                }
              }}
              className={activatePromo}
            >
              {" "}
              Activate{" "}
            </span>
          </div>
        )}
      </div>
      {(isPromoCodeActivated || isPromoCodeRejected) && showPromoText && (
        <p>
          <span
            className={`${activatedPromoText} ${
              useBgPromoText && `${promoBgText} ${promoBgSize}`
            }`}
          >
            {useBgPromoText ? (
              <CheckIcon
                height={20}
                stroke={color.background}
                className={`${promoBannerSvg} ${promoBgSvg}`}
              />
            ) : (
              <CheckIcon
                className={`${promoBannerSvg} ${useBgPromoText && promoBgSvg}`}
              />
            )}
            {promoCodeValue} code activated
          </span>
        </p>
      )}
    </>
  )
}
